import { Typography } from "@mui/material";

/** Purple "MattoAI" text tag (Image Edit nav row, Get started cards). */
export const MattoAiTag = () => (
  <Typography
    component="span"
    sx={{
      fontSize: "11px",
      fontWeight: 700,
      color: "#7C5CFA",
      lineHeight: 1,
      flexShrink: 0,
    }}
  >
    MattoAI
  </Typography>
);
